import React from "react";
import {Entity, IconEmoji, IconStatusClose, neutralColors} from "@seismic/mantle";

export const Summary = ({summary}) => {

    return <div style={{
        backgroundColor: neutralColors.white,
        padding: "8px",
        maxWidth: "1575px",
        borderRadius: "4px",
        border: `1px solid ${neutralColors.silver}`
    }}>
        <Entity
            primaryActions={[
                {
                    label: 'Good Summary',
                    startAdornment: IconEmoji,
                    onClick: () => alert('Good Summary'),
                },
                {
                    label: 'Bad Summary',
                    startAdornment: IconStatusClose,
                    onClick: () => alert('Bad Summary'),
                },
            ]}
            imgProps={{
                src: 'https://seismic.com/favicon.ico',
                alt: 'Seismic',
            }}
            children={summary}
            subject={'Summary'}
        />
    </div>
}